import { createContext, useContext } from 'react';

/**
 * When true, EntityHeader skips fetching reminders and hides reminder UI.
 * Wrap high-volume list sections (e.g. map panel) in <SkipRemindersProvider>
 * instead of threading a prop through every intermediate component.
 */
export const SkipRemindersContext = createContext(false);
export const SkipRemindersProvider = SkipRemindersContext.Provider;
export const useSkipReminders = () => useContext(SkipRemindersContext);
